import React, { useState, useContext } from "react";
import { Typography } from "@mui/material";

import { purple } from "../config";
import AlignCenter from "../components/AlignCenter";
import HTMLRenderer from "../components/HTMLRenderer";
import StyledButton from "../components/StyledButton";
import { LangContext } from "../contexts/langContext";
import "./MoreInfoDisplay.css";

const MoreInfoDisplay = ({
  title = "",
  content = "",
  fixed = false,
  buttonComponent = <></>,
  setExpanded = (val: boolean): void => undefined,
  onlyReadMore = false,
}) => {
  const [aboutExpanded, setAboutExpanded] = useState(false);
  const { translatePageText } = useContext(LangContext);

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          marginTop: 16,
          width: "100%",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        {!aboutExpanded && (
          <AlignCenter withMaxWidth>
            <div className="fadeContainer">
              <Typography>{content.replace(/<(.|\n)*?>/g, " ")}</Typography>
            </div>
          </AlignCenter>
        )}
        <StyledButton
          size="small"
          style={{ marginTop: 8 }}
          variant="quaternary"
          palette="primary"
          label={aboutExpanded ? translatePageText("general.close") : title}
          onClick={() => {
            setAboutExpanded(!aboutExpanded);
            setExpanded(!aboutExpanded);
          }}
        />
      </div>
      {aboutExpanded && (
        <div
          style={{
            minHeight: "70vh",
            marginTop: 16,
            paddingBottom: 64,
            borderRadius: 6,
            background: "white",
            position: fixed ? "fixed" : undefined,
            left: 0,
            bottom: 0,
            color: purple[500],
            transition: "height 0.5s",
            height: aboutExpanded ? "auto" : 0,
            overflow: "hidden",
            width: "100%",
          }}
        >
          <AlignCenter withMaxWidth marginTop="5vh">
            <HTMLRenderer>{content}</HTMLRenderer>
          </AlignCenter>
          {!onlyReadMore && buttonComponent}
        </div>
      )}
    </div>
  );
};

export default MoreInfoDisplay;
